import React, { useCallback, useEffect, useState } from "react";
import { useAdminApi } from "./useAdminApi";

// The platform_igdb crosswalk (LaunchBox platform_id → IGDB platform identity), the
// whole collection in one list. See GET /admin/igdb-platforms for why there's no
// paging: it's one row per physical console, a few dozen at most.
function IgdbPlatformsTab({ user, onForbidden }) {
  const apiFetch = useAdminApi(user, onForbidden);
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiFetch("/admin/igdb-platforms");
      setItems(data.items);
    } catch (err) {
      if (err.message !== "Forbidden") setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [apiFetch]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>
      {loading && <p className="admin-status">Loading…</p>}
      {error && <p className="admin-status admin-error">{error}</p>}

      <div className="admin-table glass">
        {items && items.length === 0 && <p className="admin-status">No platforms cached yet.</p>}
        {items && items.map((item) => (
          <div className="admin-row" key={item._id}>
            <div className="admin-row-main">
              <div className="admin-source-name">
                {item.igdb_platform_name}
                {item.igdb_platform_abbreviation && (
                  <code className="admin-barcode-chip admin-platform-abbr">{item.igdb_platform_abbreviation}</code>
                )}
              </div>
              <div className="admin-source-meta">
                igdb_platform_id {item.igdb_platform_id} · slug <code>{item.igdb_platform_slug}</code>
              </div>
              <div className="admin-source-meta">
                launchbox_platform_id {item.launchbox_platform_id}
                <span className="admin-source-created">{new Date(item.created_at).toLocaleString()}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {items && items.length > 0 && (
        <p className="admin-pagination-status admin-platforms-total">{items.length} platforms</p>
      )}
    </div>
  );
}

export default IgdbPlatformsTab;
